import theme from './VaultTheme';
import { addons } from '@storybook/addons';

addons.setConfig({
  theme,
});
